import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
import { createGlobalStyle } from 'styled-components';

const themeStyles = new ThemeStyles();

themeStyles.addBaseStyles('Container')(({ width = ['100vw', '100vw', '700px'] }) =>
  css({
    pb: 'l',
    backgroundColor: 'white',
    width,
    overflowY: ['hidden', 'hidden', 'auto'],
    overflowX: 'hidden',
  }),
);

themeStyles.addBaseStyles('Title')(
  css({
    backgroundColor: 'white',
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('Header')(
  css({
    width: ['100vw', 'auto', 'auto'],
    pt: 'm',
    pl: ['20px', '20px', '48px'],
    pr: ['xxs', 'xxs', 'l'],
    pb: 'xs',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: 'white',
  }),
);

themeStyles.addBaseStyles('Subtitle')(
  css({
    pb: 'xs',
  }),
);

themeStyles.addBaseStyles('IconWrapper')(
  css({
    width: '45px',
    height: '45px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
);

themeStyles.addBaseStyles('ChildrenWrapper')(({ noPadding, otherStyles }) =>
  css({
    ...otherStyles,
    px: noPadding ? 0 : ['20px', '20px', '48px'],
  }),
);

themeStyles.addBaseStyles('ButtonsWrapper')(
  css({
    mt: 'l',
    px: ['20px', '20px', '48px'],
    gap: ['m', 'm', 'default'],
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  }),
);

themeStyles.addBaseStyles('StyledButton')(
  css({
    width: ['44vw', '46vw', '290px'],
    minWidth: 'auto',
    minHeight: '45px',
    height: 'auto',
    wordBreak: 'break-all',
  }),
);

themeStyles.addBaseStyles('ModalWrapper')(({ width = ['100vw', '100vw', '700px'] }) =>
  css({
    position: ['fixed', 'relative', 'relative'],
    height: ['100lvh', '100dvh', 'auto'],
    backgroundColor: ['white', 'none', 'none'],
    width,
    '@media only print': {
      position: 'relative',
      width: 'auto',
    },
  }),
);

export const PrintModalWorkaround = createGlobalStyle`
  @media only print {
    body {
      overflow: auto !important;
    }
    portal{
      overflow: auto;
    }
    portal > div:first-child {
      display: none;
    }
    #jss-root {
      display: none;
    }
    portal > [data-focus-lock-disabled] > div {
      position: relative !important;
      overflow: visible !important;
      width: auto !important;
      height: auto !important;
      top: initial !important;
      left: initial !important;
      justify-content: initial !important
    }
    portal > [data-focus-lock-disabled] > div > div {
      padding: 0 !important;
      max-width: none !important;
      max-height: none !important;
      min-height: auto !important;
      width: auto !important;
      height: auto !important;
    }
    portal > [data-focus-lock-disabled] > div > div > div {
      min-height: auto !important;
      height: auto !important;
    }
    portal [role="dialog"] {
      padding: 0 !important;
      max-width: none !important;
      min-height: auto !important;
      width: auto !important;
      height: auto !important;
    }
    portal [role="dialog"] #container {
      overflow: visible !important;
      width: auto !important;
    }
    portal [data-body-scroll-lock-ignore] {
      overflow: visible !important;
    }
    portal [data-testid="cy-price-breakdown-print-button"] {
      display: none !important;
    }
    portal [data-testid="cy-CommonModal-title"] + div {
      display: none !important;
    }
    portal [data-testid="dsr-icon-arrowDown"] {
      display: none !important;
    }
    portal [data-testid="dsr-icon-information"] {
      display: none !important;
    }
  }
`;

export default themeStyles;
export const contentMaxHeightDifference = ['168px', '168px', '364px'];
